import type { ChatOverview } from '../../types/whatsappChat';
import { lastActivityMs } from './chatListRules';

/** Merge a delayed server snapshot into the live list without undoing newer messages.
 * Keep loaded pages and drafts; on equal activity retain the previous relative order.
 */
export function mergeChatOverview(current: ChatOverview[], incoming: ChatOverview[]): ChatOverview[] {
  const result = new Map(current.map(chat => [chat.id, chat]));
  for (const chat of incoming) {
    const previous = result.get(chat.id);
    result.set(chat.id, previous ? {
      ...previous, ...chat,
      lastMessage: lastActivityMs(previous) > lastActivityMs(chat) ? previous.lastMessage : chat.lastMessage,
      unreadCount: previous.unreadCount ?? chat.unreadCount,
    } : chat);
  }
  return [...result.values()].sort((a, b) =>
    Number(b.pinned) - Number(a.pinned) || lastActivityMs(b) - lastActivityMs(a));
}
